import { FC, PropsWithChildren } from 'react';
import { type ColorSchemeResolution, readInitialColorScheme } from '@glomopay/shadcn/color-scheme';
import { ThemeProvider } from '@glomopay/shadcn/theme-provider';

import { analytics } from '@/features/analytics/public';
import { useIsDarkModeEnabled } from '@/features/portal-shell/public';
import { useTenant } from '@/features/tenant/public';
import { logger } from '@/lib/logger';

export const InvestorColorSchemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const darkModeFlag = useIsDarkModeEnabled();
  const { tenant } = useTenant();
  const isWhitelabel = tenant.isWhitelabel === true;
  const hasProfile = darkModeFlag !== undefined;
  const isDarkModeEnabled = darkModeFlag === true && !isWhitelabel;
  const requestedColorScheme = readInitialColorScheme() ?? 'light';

  const onColorSchemeResolved = ({ colorScheme, colorSchemeSource }: ColorSchemeResolution) => {
    logger.info('investor portal colour scheme resolved', { colorScheme, colorSchemeSource, isDarkModeEnabled, requestedColorScheme, isWhitelabel });
    analytics.setContext({ color_scheme: colorScheme, color_scheme_source: colorSchemeSource });
  };

  return (
    <ThemeProvider
      enabled={isDarkModeEnabled}
      forcedTheme={requestedColorScheme}
      isResolving={!hasProfile}
      onColorSchemeResolved={onColorSchemeResolved}>
      {children}
    </ThemeProvider>
  );
};
